module.exports = __webpack_public_path__ + "static/img/zryt-jxml.f03601cf.png";